import {useTranslation} from 'gatsby-plugin-react-i18next';
import React, {FC} from 'react';
import {useForm} from 'react-hook-form';
import useBreakpoint from 'design-system/src/WebComponent/Grid/hooks/useBreakpoint';
import AlreadyHaveAccount from './components/AlreadyHaveAccount';
import SignupEmailFormContent from './components/SignupEmailFormContent';

interface SignupEmailFormProps {
  onSubmit: (email: string) => void;
  onSignInClick: () => void;
}

const SignupEmailForm: FC<SignupEmailFormProps> = ({
  onSubmit,
  onSignInClick,
}) => {
  const {t} = useTranslation('auth');
  const {isMobile} = useBreakpoint();
  const {control, handleSubmit} = useForm<{
    email: string;
  }>();

  const handleFormSubmit = handleSubmit(
    () => onSubmit(control._formValues.email),
    (error: any) => {
      console.log(error);
    },
  );

  return (
    <>
      <SignupEmailFormContent
        control={control}
        isMobile={isMobile}
        t={t}
        handleFormSubmit={handleFormSubmit}
      />

      <AlreadyHaveAccount onSignInClick={onSignInClick} />
    </>
  );
};

export default SignupEmailForm;
